export default {
  mybidding: {
    searchPlaceholder: '输入竞价项目编号或名称查询',
    purchasingUnit: '采购单位',
    biddingNo: '项目编号',
    biddingName: '项目名称',
    biddingMode: '竞价模式',
    releaseDate: '项目发布时间',
    startTime: '竞价开始时间',
    endTime: '竞价结束时间',
    biddingSupplierCount: '竞价单位数',
    statusName: '竞价状态',
    purOfficeNo: '采购中心',
    dateTimeRange: '竞价时间',
    biddinghall: '竞价大厅',
    seeDetail: '查看结果'
  },
  biddinghall: {
    biddinghall: '竞价大厅',
    whiteForm: '填写竞价报表',
    goodsType: '类型',
    number: '编码',
    name: '名称',
    expirationDate: '失效日期',
    model: '型号',
    category: '所属类目',
    technologyName: '工艺',
    unit: '单位',
    currencyNo: '币种',
    qty: '数量',
    fixedPrice: '限价',
    giveUpSign: '是否放弃',
    goodsPrice: '单价(含税)',
    taxRate: '税率',
    taxIncludedAmount: '总金额',
    remarks: '供方备注',
    purchaseStandard: '采购标准',
    expectedDeliveryDate: '期望交货日期',
    goodsFileList: '附件',
    giveUp: '放弃报价',
    submit: '提交报价'
  },
  biddingresult: {
    biddingresult: '查看结果'
  },
  biddingsignup: {
    searchPlaceholder: '输入竞价项目编号或名称查询',
    purOfficeName: '采购中心',
    biddingNo: '项目编号',
    biddingName: '项目名称',
    biddingMode: '竞价模式',
    signUpDeadline: '报名截止时间',
    releaseDate: '项目发布时间',
    startTime: '竞价开始时间',
    signStatus: '状态',
    refuseReason: '拒绝原因',
    purOfficeNo: '采购单位',
    signOptionsAll: {
      '1': '待报名',
      '2': '审核中',
      '3': '已拒绝',
      '4': '已入围'
    },
    operate: {
      enter: '报名'
    }
  },
  enroll: {
    enroll: '竞价报名',
    biddingDetail: '竞价明细',
    joinsup: '竞价企业',
    supOfficeName: '供应商名称',
    status: '状态',
    statusNames: ['已拒绝', '待审核', '已入围'],
    adddate: '报名时间',
    submit: '参与报名',
    countDownTip: '距离报名结束还有'
  }
}
